export const DEFAULT_MONTHLY_OBJECT_VALUE = {
  jan: 0,
  feb: 0,
  mar: 0,
  apr: 0,
  may: 0,
  jun: 0,
  jul: 0,
  aug: 0,
  sep: 0,
  oct: 0,
  nov: 0,
  dec: 0,
  total: 0,
};

export const SCGC_Subsidiary = [
  "MOC",
  "ROC",
  "Chemtech",
  "TPC Indo",
  "TPC RY",
  "TPC Vina",
  "Viet-Thai",
  "TPE",
  "BMP",
  "NPI RY",
  "NPI SB",
  "NPIC",
  "SCGC ICO",
  "Cirplas",
  "LSP-Downstream",
  "LSP-Upstream",
];

export const SCGC_JV = ["TMMA", "GSC", "STC", "TMFC"];
export enum COMPANY_GROUP {
  SCGC_ALL = "SCGC All",
  SCGC_SUBSIDIARY = "SCGC Subsidiary",
  SCGC_JV = "SCGC JV",
}

export const DROPDOWN_COMPANY_LISTS = [
  "MOC",
  "ROC",
  "TPE",
  "Cirplas".toUpperCase(),
  "TMMA",
  "GSC",
  "TMFC",
  "LSP-Downstream".toUpperCase(),
  "LSP-Upstream".toUpperCase(),
  "TPC-RY".toUpperCase(),
  "MTT".toUpperCase(),
  "RTC".toUpperCase(),
];

export const blackListGlobalCommentsInformation = ["/production", "/report", "/target", "/status"];

export const list_include_others_inventory = ["TPC-RY", "TPE"];

export enum INVENTORY_LABEL_ENUM {
  Fugitive = "Fugitive",
  Combustion = "Combustion",
  Flare = "Flare",
  Tank = "Tank",
  TransportAndMarketing = "Transport & Marketing",
  WasteWater = "Wastewater",
  Others = "Others",
}

export const INVENTORIES_ARRAY = [
  INVENTORY_LABEL_ENUM.Fugitive,
  INVENTORY_LABEL_ENUM.Combustion,
  INVENTORY_LABEL_ENUM.Flare,
  INVENTORY_LABEL_ENUM.TransportAndMarketing,
  INVENTORY_LABEL_ENUM.Tank,
  INVENTORY_LABEL_ENUM.WasteWater,
  INVENTORY_LABEL_ENUM.Others,
];

export enum INVENTORY_FIELD_ENUM {
  Fugitive = "fugitive",
  Combustion = "combustion",
  Flare = "flare",
  Tank = "tank",
  TransportAndMarketing = "transportAndMarketing",
  WasteWater = "wasteWater",
  Others = "others",
}

export const MAPPING_LABEL_TO_KEY = {
  [INVENTORY_LABEL_ENUM.Fugitive]: INVENTORY_FIELD_ENUM.Fugitive,
  [INVENTORY_LABEL_ENUM.Combustion]: INVENTORY_FIELD_ENUM.Combustion,
  [INVENTORY_LABEL_ENUM.Flare]: INVENTORY_FIELD_ENUM.Flare,
  [INVENTORY_LABEL_ENUM.Tank]: INVENTORY_FIELD_ENUM.Tank,
  [INVENTORY_LABEL_ENUM.TransportAndMarketing]: INVENTORY_FIELD_ENUM.TransportAndMarketing,
  [INVENTORY_LABEL_ENUM.WasteWater]: INVENTORY_FIELD_ENUM.WasteWater,
  [INVENTORY_LABEL_ENUM.Others]: INVENTORY_FIELD_ENUM.Others,
};

export enum ReportStatusEnum {
  PROCESSING = "processing",
  REQUEST = "request",
  APPROVER_1 = "approver_1",
  APPROVER_2 = "approver_2",
  APPROVER_3 = "approver_3",
  REJECT = "reject",
}

export const MAPPING_PATH_TO_VOCS_REPORT = {
  [INVENTORY_FIELD_ENUM.Fugitive]: "/vocs-inventory/fugitive/report-voc-emission",
  [INVENTORY_FIELD_ENUM.Combustion]: "/vocs-inventory/combustion/report-voc-emission",
  [INVENTORY_FIELD_ENUM.Flare]: "/vocs-inventory/flare/report-voc-emission",
  [INVENTORY_FIELD_ENUM.Tank]: "/vocs-inventory/tank/report-voc-emission",
  [INVENTORY_FIELD_ENUM.TransportAndMarketing]: "/vocs-inventory/transportation-and-marketing/report-voc-emission",
  [INVENTORY_FIELD_ENUM.WasteWater]: "/vocs-inventory/waste-water-treatment/report-voc-emission",
  [INVENTORY_FIELD_ENUM.Others]: "/vocs-inventory/others/report",
};

export enum CalculationMethodOthersEnum {
  FILL_EMISSION = "fillEmission",
  STACK_SAMPLING = "stackSampling",
}

export const DISPLAY_SAMPLING_RESULT = {
  flowRate: "Flow Rate",
  concentration: "Concentration",
  molecularWeight: "Molecular Weight",
  operatingHour: "Operating Hour",
  reference: "Reference",
};
